import axios from 'axios';
import { BASE_URL } from '../components/Constant';

//create token
function createPasswordResetToken(email) {
  const endpoint = BASE_URL + 'passwordResetToken/createResetToken';

  return axios.post(
    endpoint,
    { email: email },
    {
      headers: {
        // eslint-disable-next-line no-undef
        authorization: `${localStorage.getItem('token')}`
      }
    }
  );
}

//reset pass using token, email and new pass
function resetPassword(resetPassObj) {
  const endpoint = BASE_URL + 'passwordResetToken/resetPassword';

  return axios.put(
    endpoint,
    { resetPassObj: resetPassObj },
    {
      headers: {
        // eslint-disable-next-line no-undef
        authorization: `${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
      }
    }
  );
}

const passwordService = {
  createPasswordResetToken,
  resetPassword
};

export default passwordService;
